/**
 * WARNING
 *
 * Changing these labels will trickle out to several areas of the app. Proceed with caution.
 */

export enum HomeSectionLabel {
    MY_FAVORITES = 'My Favorites',
    JUST_FOR_ME = 'Just for Me',
    FUNDAMENTALS = 'Fundamentals',
    NEWS_FROM_GENESYS = 'News from Genesys',
    ARCHIVES = 'Roadmap Archives',
}

export enum JustForMeSectionLabel {
    MY_FAVORITES = 'My Favorites',
    BEYOND_TRAINING = 'Beyond Training',
    MY_AWARDS = 'My Awards',
    MY_CONTACTS = 'My Contacts',
    MY_CASES = 'My Cases',
    KNOWLEDGE_BASE = 'Knowledge Base',
    MY_PERSONALIZED_VIDEO = 'My Personalized Video',
    ADDITIONAL_SITES = 'Additional Sites',
}

export enum NewsFromGenesysFilterLabel {
    ALL = 'All',
    ANNOUNCEMENTS = 'Announcements',
    BLOG = 'Blog',
    SOCIAL = 'Social',
}

export enum CommunitySectionLabel {
    LATEST_DISCUSSIONS = 'Latest Discussions',
    QA_SHOW = 'Community Q&A Show',
    RELATED_COMMUNITIES = 'Related Communities',
}

export enum GetInvolvedSectionLabel {
    MARKETING_EVENTS = 'Virtual and Physical Events',
    CONNECT_WITH_GENESYS = 'Connect with Genesys',
}
export enum EduTrainingSectionLabel {
    BEYOND_TRAINING = 'Beyond Training',
    GEN_ED = 'GenEd Training',
    CERTIFICATIONS_AND_BADGES = 'Certifications & Badges',
    CS_ACADEMY = 'CS Academy Training',
    EDU_EVENTS_AND_WEBINARS = 'Webinars',
}

export enum EduTrainingBadgesFilterLabel {
    MY_AWARDS = 'My Awards',
    GET_CERTIFIED = 'Get Certified',
}

export enum ResourcesSectionLabel {
    ADVOCACY = 'Advocacy',
    APPFOUNDRY = 'AppFoundry',
    BOOST_YOUR_KNOWLEDGE_WEBINARS = 'Boost Your Knowledge webinars',
    BOOST_YOUR_KNOWLEDGE_WEBINARS_LIBRARY = 'Boost Your Knowledge webinars library',
    CAPABILITY_ACCELERATOR = 'Capability Accelerator',
    CAPABILITY_ACCELERATOR_SUBPAGE = 'Adopt with confidence',
    CAPABILITY_ACCELERATOR_AGENT_COPILOT = 'Agent Copilot',
    CAPABILITY_ACCELERATOR_GPR = 'Genesys Predictive Routing',
    CAPABILITY_ACCELERATOR_STA = 'Speech and Text Analytics',
    CAPABILITY_ACCELERATOR_WEB_MESSAGING = 'Web Messaging',
    // TODO For future
    // CAPABILITY_ACCELERATOR_WEM = 'WEM',
    CX_EVOLUTION = 'CX Evolution',
    CX_EVOLUTION_GET_STARTED = 'Get started',
    CX_EVOLUTION_CONNECT = 'Connect',
    CX_EVOLUTION_LEARN_FROM_OTHERS = 'Learn from others',
    DEVELOPER_CENTER = 'Developer Center',
    DEVELOPER_CENTER_TOOLS = 'Tools',
    DEVELOPER_CENTER_POPULAR_TOPICS = 'Popular topics',
    DEVELOPER_CENTER_BLOGS = 'Blogs',
    EXPERT_APPS = 'Genesys Expert Apps',
    GENESYS_BLOG = 'Genesys blog',
    GENESYS_EVENTS = 'Genesys events',
    GENESYS_NEWS = 'Genesys news',
    GENESYS_NEWS_AND_EVENTS = 'Genesys news and events',
    GENESYS_SOCIAL = 'Genesys on social',
    MY_PERSONALIZED_VIDEO = 'My Personalized Video',
    ONBOARDING = 'Onboarding: Starter Kits, Webinars and Short Tracks',
    PRODUCT_KNOWLEDGE = 'Product knowledge',
    PRODUCT_HELP = 'help', // append to currently selected product
    STARTER_KITS = 'Starter Kits',
    STARTER_KITS_GC = 'Genesys Cloud Starter Kit',
    STARTER_KITS_WEM = 'Genesys Cloud WEM/EX Starter Kit',
    SHORT_TRACKS = 'Short Tracks',
    TIPS_AND_TOOLS = 'Tips and tools',
    UX_RESEARCH_PROGRAM = 'UX Research Program',
}

export enum GetStartedSectionLabel {
    USEFUL_LINKS = 'Useful Links',
    TIPS_AND_TOOLS = 'Tips and Tools',
}

/**
 * These are mapped one to one with filters in Strapi
 * Do not update these without also updating them in Strapi
 */
export enum CxEvolutionFilterLabel {
    GET_STARTED = 'Get Started',
    CONNECT = 'Connect',
    LEARN_FROM_OTHERS = 'Learn from Others',
}

export enum DevCenterFilterLabel {
    TOOLS = 'Tools',
    POPULAR_TOPICS = 'Popular Topics',
    BLOGS = 'Blogs',
}

export enum GetStartedFilterLabel {
    STARTER_KIT = 'Starter Kit',
    USEFUL_LINKS = 'Useful Links',
    MY_PERSONALIZED_VIDEO = 'My Personalized Video',
    TIPS_AND_TOOLS = 'Tips and Tools',
    NEW_CUSTOMER_ONBOARDING = 'Onboarding Webinars',
    SHORT_TRACKS = 'Short Tracks',
}

export enum SearchResultsFilterLabel {
    ALL = 'All',
    DOCUMENTATION = 'Documentation',
    TRAINING = 'Training',
    DEVELOPER_CENTER = 'Developer Center',
    COMMUNITY = 'Community',
    BLOG = 'Blog',
}

export enum SearchResultsFilterTerm {
    ALL = 'all',
    DOCUMENTATION = 'resource',
    DOCS = 'docs',
    TRAINING = 'training',
    DEVELOPER_CENTER = 'developer', // developer_center is used by Genesys Cloud, developer_article used by Engage
    COMMUNITY = 'community',
    BLOG = 'blog',
}

export enum StarterKitTabName {
    GENESYS_CLOUD_CX = 'Genesys Cloud',
    GENESYS_CLOUD_CX_DIGITAL = 'Genesys Cloud Digital',
    GENESYS_CLOUD_WEM_EX = 'Genesys Cloud WEM/EX',
}

export enum StarterKitFilterLabel {
    GENESYS_CLOUD_CX = 'gc-cx',
    GENESYS_CLOUD_CX_DIGITAL = 'gc-cx-digital',
    GENESYS_CLOUD_WEM_EX = 'gc-wem-ex',
}

export enum SupportSectionLabel {
    MY_CASES = 'My Cases',
    PRODUCT_SUPPORT_CENTER = 'Product Support',
    MY_CONTACTS = 'My Contacts',
    RECOMMENDATIONS = 'Recommendations',
}

export enum ProductHelpFilterLabel {
    ARTICLES = 'Articles',
    DOCUMENTATION = 'Documentation',
    VIDEOS = 'Videos',
    USE_CASES = 'Use Cases',
}

export enum NewsLabel {
    PUBLISHED = 'Published',
}

export enum NewsOrigin {
    ANNOUNCEMENT = 'announcement',
    BLOG = 'blog',
    FACEBOOK = 'facebook',
}

export enum SearchResultLabel {
    SEARCHRESULT = 'searchResult',
}

export enum MyProfileLabel {
    MY_PROFILE = 'My Profile',
}

export enum LegacyGetStartedLabel {
    GET_STARTED = 'Get Started',
}

export enum GKNStoriesSectionLabel {
    GKN_STORIES = 'GKN Stories',
}

export enum RecommendationSectionLabel {
    RECOMMENDATIONS = 'Recommendations',
}
